import { IoLocation } from "react-icons/io5";
import { MdOutlineEdit } from "react-icons/md";
import { MdDelete } from "react-icons/md";

import styles from "./Card.module.css";
import { CardMapValue } from "../../Layout/CardLayout";
import { useNavigate } from "react-router";

export interface CardProps {
  item: CardMapValue;
  edit: boolean;
  index?: number;
  onDelete?: (id: string) => void;
  onEdit?: (id: string) => void;
}

export default function Card(data: CardProps) {
  const navigate = useNavigate();
  console.log(data.item);
  console.log(data.item.images.values);
  return (
    <>
      <div className={styles.card}>
        <button
          className={styles.buttonCard}
          onClick={() =>
            navigate(`/category/${data.item.sellRent}/${data.item.id}`)
          }
        >
          <div className={styles.cardImage}>
            <img src={data.item.images?.values[0]?.stringValue} alt="card" />
          </div>
          <div className={styles.cardDetails}>
            <div className={styles.location}>
              <span className={styles.locationIcon}>
                <IoLocation />
              </span>
              <span className={styles.address}>{data.item.address}</span>
            </div>
            <p className={styles.description}>{data.item.description}</p>
            <span className={styles.price}>
              <span className={styles.priceValue}>{data.item.price}</span> $
            </span>
          </div>
        </button>
        <div className={styles.footer}>
          <div className={styles.bedsBaths}>
            <span>
              <span className={styles.BedsValue}>{data.item.beds}</span>{" "}
              <span>Beds</span>
            </span>
            <span>
              <span className={styles.BathsValue}>{data.item.baths}</span>{" "}
              <span>Baths</span>
            </span>
          </div>
          {data.edit ? (
            <div className={styles.ButtonContainer}>
              <button
                className={styles.edit}
                onClick={() => {
                  data.onEdit && data.onEdit(data.item.id);
                }}
              >
                <MdOutlineEdit />
              </button>
              <button
                className={styles.delete}
                onClick={() => {
                  data.onDelete && data.onDelete(data.item.id);
                }}
              >
                <MdDelete />
              </button>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
}
